import { Briefcase, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { AppointmentTypeConfig } from "@/components/clinical/AppointmentTypeConfig";

export const ClinicalWorkflow = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Clinical Workflow Integration
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Seamlessly integrate Scienza Health into your existing clinical workflows
          </p>
        </div>

        <div className="mb-12">
          <AppointmentTypeConfig />
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <Card className="p-6 hover:shadow-lg transition-shadow duration-300">
            <div className="bg-primary/10 p-3 rounded-lg w-12 h-12 flex items-center justify-center mb-4">
              <Briefcase className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Patient Assessment</h3>
            <p className="text-gray-600 mb-4">
              Streamlined cognitive assessment process integrated with your EHR system
            </p>
            <Link to="/enterprise/patient-assessment">
              <Button variant="link" className="text-primary flex items-center gap-2">
                Learn More <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </Card>

          <Card className="p-6 hover:shadow-lg transition-shadow duration-300">
            <div className="bg-primary/10 p-3 rounded-lg w-12 h-12 flex items-center justify-center mb-4">
              <Briefcase className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Care Planning</h3>
            <p className="text-gray-600 mb-4">
              AI-powered care plan recommendations based on assessment results
            </p>
            <Link to="/enterprise/care-planning">
              <Button variant="link" className="text-primary flex items-center gap-2">
                Learn More <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </Card>

          <Card className="p-6 hover:shadow-lg transition-shadow duration-300">
            <div className="bg-primary/10 p-3 rounded-lg w-12 h-12 flex items-center justify-center mb-4">
              <Briefcase className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Progress Tracking</h3>
            <p className="text-gray-600 mb-4">
              Comprehensive monitoring and reporting of patient progress
            </p>
            <Link to="/enterprise/progress-tracking">
              <Button variant="link" className="text-primary flex items-center gap-2">
                Learn More <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </Card>
        </div>
      </div>
    </section>
  );
};